import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // Class Definition
    OndigoNS.Slider = function (element) {
        var _instance = this;

        this.$window = $(window);
        this.$slider = $(element);
        this.$sliderOverflow = $('.sliderOverflow', this.$slider);
        this.$slidesWrapper = $('.slidesWrapper', this.$slider);
        this.$button = $('.sliderButton', this.$slider);
        this.$slides = $('.slide', this.$slider);
        this.descriptionMaxHeight = 0;
        this.$slideIndicatorWrapper = $('.slideIndicatorWrapper', this.$slider);
        this.$nextButton = $('.next', this.$slider);
        this.$prevButton = $('.prev', this.$slider);

        this.$desktopImage = $('.sliderDesktopImage', this.$slider);

        this.autoSlideInterval = 6000; // fallback
        this.stopSliderAnimation = false;
        this.slideTimer = null;
        this.currentPage = 0;
        this.slideCount = this.$slides.length;
        this.isAnimating = false;
        this.currentMargin = 0;
        this.slideAnimatedWithSwipe = false;
        this.swipingPoint = 75;
        this.activeBreakpoint = this.getActiveBreakPoint();
        this.imageResFactor = this.$slides.eq(0).find('img.'+this.activeBreakpoint).eq(0).data('resolution-factor');

        this.init = true;

        this.createSlideIndicator();
        this.determineActiveBreakpoint();
        this.updateSliderDimensions();

        if(this.$slider.hasClass('imageToSlider')) {
            this.switchImageAndSlider();
        }

       this.$window.on('load', function () {
            _instance.preloadImage(false, false); // preload the next image

            if (_instance.$slider.hasClass('autoSlide')) {
                _instance.autoSlideInterval = parseInt(_instance.$slider.data('auto-slide-speed'), 10);

                _instance.autoSlide();

                _instance.$slider.hover(function () {
                        window.clearTimeout(_instance.slideTimer);
                    },
                    function () {
                        _instance.autoSlide();
                    }
                );
            }
        });

        if (OndigoNS.Utils.hasTouchscreen()) {
            this.$window.on('orientationchange', function () {
                setTimeout(function () {
                    _instance.determineActiveBreakpoint();
                    _instance.updateSliderDimensions();
                }, 300);
            });

            this.$sliderOverflow.swipe({
                swipeStatus: $.proxy(_instance.swipeSlide, this),
                threshold: 10,
                maxTimeThreshold: 2500,
                fingers: 'all',
                allowPageScroll: 'vertical'
            });
        }
        else {
            this.$window.on('resize', function () {
                setTimeout(function () {
                    _instance.determineActiveBreakpoint();
                    _instance.updateSliderDimensions();
                }, 100);
            });
        }

        this.$button.on('click', function (e) {
            _instance.updateCurrentElement(e);
        });

        _instance.fadeInNavigationalElements();

    };

    OndigoNS.Slider.prototype = {
        determineActiveBreakpoint: function () {
            var activeBreakpoint,
                $imageToBeLoaded;

            activeBreakpoint = this.getActiveBreakPoint();
            $imageToBeLoaded = $(this.$slides[this.currentPage]).find('img.' + activeBreakpoint);

            if (this.activeBreakpoint !== activeBreakpoint || $imageToBeLoaded.attr('src') === '' || parseInt($imageToBeLoaded.attr('autoload'), 10) === 0) {

                this.activeBreakpoint = activeBreakpoint;

                if (this.init) {
                    this.preloadImage(true, false);
                    this.preloadImage(false, false);

                    this.init = false;
                } else {
                    this.preloadImage(true, false);
                }
            }
        },
        /**
         *
         * @param loadNow (if true load the $activeImage)
         * @param loadPreviousImage (if true load the image previous to $activeImage)
         */
        preloadImage: function (loadNow, loadPreviousImage) {
            var $imageToBeLoaded,
                imageToBeLoadedSource,
                _instance = this;

            if (loadNow) {
                // dot-nav used, need to load current image
                $imageToBeLoaded = $(this.$slides[this.currentPage]).find('img.' + this.activeBreakpoint);
            } else if (loadPreviousImage) {
                $imageToBeLoaded = $(this.$slides[this.currentPage - 1]).find('img.' + this.activeBreakpoint);
            } else {
                $imageToBeLoaded = $(this.$slides[this.currentPage + 1]).find('img.' + this.activeBreakpoint);
            }


            if (($imageToBeLoaded.length && $imageToBeLoaded.attr('src') === '') || parseInt($imageToBeLoaded.attr('autoload'), 10) === 0) {
                if (window.devicePixelRatio > 1) {
                    imageToBeLoadedSource = $imageToBeLoaded.data('retina');
                } else {
                    imageToBeLoadedSource = $imageToBeLoaded.data('image-source');
                }
                if (loadNow) {
                    $imageToBeLoaded[0].onload = function () {
                        _instance.updateSliderDimensions();
                    };
                }

                $imageToBeLoaded.attr('src', imageToBeLoadedSource);
            }
        },
        fadeInNavigationalElements: function () {
            this.$nextButton.fadeIn(0);
            this.$slideIndicatorWrapper.fadeIn(0);
        },
        swipeSlide: function (event, phase, direction, distance) {

            if (this.currentPage < this.slideCount - 1 && direction === 'left' && this.slideAnimatedWithSwipe === false) {

                this.$slidesWrapper.css({
                    'margin-left': this.currentMargin - distance
                });

                if (distance > this.swipingPoint) {

                    this.slideAnimatedWithSwipe = true;

                    this.currentPage++;

                    this.updateActiveSlide();
                    this.animateSlide();
                }
            } else if (this.currentPage > 0 && this.slideCount && direction === 'right' && this.slideAnimatedWithSwipe === false) {

                this.$slidesWrapper.css({
                    'margin-left': this.currentMargin + distance
                });

                if (distance > this.swipingPoint) {

                    this.slideAnimatedWithSwipe = true;

                    this.currentPage--;

                    this.updateActiveSlide();
                    this.animateSlide();
                }
            }

            if (phase === 'end') {
                this.slideAnimatedWithSwipe = false;
                this.animateSlide();
            }
        },
        createSlideIndicator: function () {
            var indicatorItems = '<li class="indicator active"></li>',
                _instance = this,
                i = 1;

            for (i; i < this.slideCount; i++) {
                indicatorItems += '<li class="indicator"></li>';
            }

            this.$slideIndicatorWrapper.children().append(indicatorItems);

            this.$slideIndicatorWrapper.find('li').on('click', function (e) {
                _instance.dotNavigation(e);
            });
        },
        dotNavigation: function (e) {
            this.currentPage = $(e.target).index();
            this.currentMargin = -this.$slider.width() * this.currentPage;

            this.preloadImage(true, false);
            this.updateActiveSlide();
            this.animateSlide();
        },
        updateSliderDimensions: function () {
            this.currentMargin = -this.$slider.width() * this.currentPage;
            this.imageResFactor = this.$slides.eq(0).find('img.' + this.activeBreakpoint).eq(0).data('resolution-factor');

            var imageMaxHeight = this.$slider.width() / this.imageResFactor,
                _instance = this,
                finalheight,
                textBoxPresent = $('.row', this.$slides).length > 0,
                padding = 15;

            this.$slides.width(this.$slider.width());
            this.descriptionMaxHeight = 0;

            this.$slidesWrapper.css({
                'margin-left': this.currentMargin,
                'width': this.$slider.width() * this.slideCount
            });

            if(this.$slider.hasClass('referenceSlider')) {
                this.setReferenceSliderDimensions();
            } else {
                if(textBoxPresent) {
                    $.each(this.$slides, function () {
                        var $this = $(this),
                            $slideDescription = $('.row .content', $this),
                            h = $slideDescription.height() + padding;
                        _instance.descriptionMaxHeight = Math.max(h, _instance.descriptionMaxHeight);
                    });
                }

                finalheight = this.descriptionMaxHeight + imageMaxHeight;

                if (finalheight === 0) {
                    return;
                }

                this.$sliderOverflow.css({
                    'height': finalheight + 'px'
                });

                this.$slides.height('auto');
                this.$slides.css({'height': finalheight});
            }
        },
        updateCurrentElement: function (e) {
            if (!this.isAnimating) {
                var _instance = this,
                    $currentImage,
                    imageToBeLoadedSource;
                this.isAnimating = true;

                if ($(e.target).hasClass('prev')) {
                    this.currentPage--;

                    this.preloadImage(true, false); // load the previous image
                    this.preloadImage(false, true); // load the image before that one
                } else {
                    this.currentPage++;
                }

                $currentImage = $(this.$slides[this.currentPage]).find('img.' + this.activeBreakpoint);

                if ($currentImage.attr('src') === '') {
                    $currentImage[0].onload = function () {
                        _instance.updateSliderDimensions();
                    };

                    if (window.devicePixelRatio > 1) {
                        imageToBeLoadedSource = $currentImage.data('retina');
                    } else {
                        imageToBeLoadedSource = $currentImage.data('image-source');
                    }
                    $currentImage.attr('src', imageToBeLoadedSource);
                }

                this.updateActiveSlide();
                this.animateSlide();
            }
        },

        getActiveBreakPoint : function () {
            var state = 'desktop';

            if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointSliderImageCondition) {
                state = 'smartphone';
            } else if(OndigoNS.Utils.getWindowInnerWidth() >= OndigoNS.breakpointSliderImageCondition && OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                state = 'tablet';
            }

            return state;
        },

        updateActiveSlide: function () {
            this.init = false; //slide needs to be updated, which means we survived the init-phase

            if (this.currentPage === this.slideCount - 1) {
                this.$nextButton.hide();
                this.$prevButton.show();
            } else if (this.currentPage < 1) {
                this.$prevButton.hide();
                this.$nextButton.show();
            } else {
                this.$button.show();
            }

            this.currentMargin = -this.$slider.width() * this.currentPage;

            this.preloadImage(true, false);
        },
        animateSlide: function () {
            var _instance = this;

            this.$slidesWrapper.animate({
                'margin-left': this.currentMargin
            }, 300, function () {
                _instance.isAnimating = false; //allow another animation
            });

            // update slide indicator
            this.$slideIndicatorWrapper.find('li').removeClass('active');
            $(this.$slideIndicatorWrapper.find('li')[this.currentPage]).addClass('active');
        },
        autoSlide: function () {
            if (OndigoNS.Utils.getWindowInnerWidth() >= OndigoNS.breakpointWide) {
                var _instance = this;
                this.slideTimer = window.setTimeout(function () {
                    if (!_instance.stopSliderAnimation) {
                        _instance.currentPage++;
                        if (_instance.currentPage === _instance.slideCount) {
                            _instance.currentPage = 0;
                        }
                        _instance.preloadImage(false, false);
                        _instance.updateActiveSlide();
                        _instance.animateSlide();

                        _instance.autoSlide();
                    }
                }, _instance.autoSlideInterval);
            }
        },
        switchImageAndSlider : function () {
            if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                this.$sliderOverflow.removeClass('hidden');
                this.$desktopImage.addClass('hidden');
            } else {
                this.$sliderOverflow.addClass('hidden');
                this.$desktopImage.removeClass('hidden');
            }
        },
        setReferenceSliderDimensions : function () {
            var heights = [],
                maxHeight,
                slideHeight = this.$slides.find('.imageWrapper img.smartphone').width() / this.$slides.find('.imageWrapper img.smartphone').data('resolution-factor');

            if(OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                // add all heights to the array
                $.each(this.$slides.find('.textWrapper'), function () {
                    $(this).css('height','');
                    heights.push($(this).outerHeight());
                });

                maxHeight = OndigoNS.Utils.maxValueInArray(heights);

                this.$slides.height(maxHeight + slideHeight);
                this.$sliderOverflow.height(maxHeight + slideHeight);
            }
        }
    };

    // plugin definition
    $.fn.slider = function () {
        return new OndigoNS.Slider(this);
    };
    $.fn.slider.Constructor = OndigoNS.Slider;

}(window.jQuery));


$(document).ready(function () {
    'use strict';

    var $slider = $('.slider');
    if ($slider.length) {
        $.each($slider, function () {
            $(this).slider();
        });
    }
});